import {
  currencyCodeToSymbol,
  currencyConversionRates,
} from "~/constants/currency.ts";
import { useOrgStore } from "~/store/org";

export const convertCurrency = (amount: number) => {
  const orgStore = useOrgStore();
  // Assumption: All AVEs are in Euros.
  // Ref: https://onclusive.atlassian.net/browse/O360-767?focusedCommentId=430035
  const orgCurrency = orgStore.org?.attributes?.currency;

  if (orgCurrency === "UNCONVERTED") {
    // For Unconverted just show the AVE without Currency Symbol
    return amount;
  }

  const rate = currencyConversionRates.EUR[orgCurrency];
  const convertedAmount = Math.round(amount * rate * 100) / 100;
  return `${currencyCodeToSymbol[orgCurrency]}${convertedAmount}`;
};
